import { useState } from "react";
import { NavLink } from "react-router-dom";
import { FaHome, FaFilm, FaTv, FaFire, FaBars, FaTimes } from "react-icons/fa"; 
import "./Header.css";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <header className="site-header">
      {/* Logo الموقع */}
      <NavLink to="/" className="logo-box">
        <img src="/logo.png" alt="MovieFree" className="site-logo" />
        <span className="site-name">MovieFree</span>
      </NavLink>

      {/* أيقونة الهامبورغر للهواتف */}
      <button className="menu-toggle" onClick={toggleMenu}>
        {menuOpen ? <FaTimes /> : <FaBars />}
      </button>

      {/* Navigation مع أيقونات SVG */}
      <nav className={`main-nav ${menuOpen ? "open" : ""}`}>
        <NavLink to="/" end className="nav-link" onClick={() => setMenuOpen(false)}>
          <FaHome className="nav-icon" /> الرئيسية
        </NavLink>
        <NavLink to="/movies" className="nav-link" onClick={() => setMenuOpen(false)}>
          <FaFilm className="nav-icon" /> أفلام
        </NavLink>
        <NavLink to="/series" className="nav-link" onClick={() => setMenuOpen(false)}>
          <FaTv className="nav-icon" /> مسلسلات
        </NavLink>
        <NavLink to="/trending" className="nav-link" onClick={() => setMenuOpen(false)}>
          <FaFire className="nav-icon" /> الأكثر مشاهدة
        </NavLink>
      </nav>
    </header>
  );
}
